import i18next from 'i18next'
import { declensionByNum } from 'www/utils'
import getUserLanguage from 'src/utils/getUserLanguage'
import type { DoctorCaseImage } from 'www/vue_components/common/DoctorCases/types'
import { PERIOD_CASES } from 'www/vue_components/common/DoctorCases/constants'

const userLanguage = getUserLanguage()

export default function getPeriodText({ period, interval, state }: DoctorCaseImage) {
  if (!period) {
    return state === 'before'
      ? i18next.t('до процедуры', { ns: userLanguage })
      : ''
  }

  if (period === 'at_once') {
    return i18next.t(PERIOD_CASES[period][0], { ns: userLanguage })
  }

  return interval
    ? `${i18next.t('через', { ns: userLanguage })} ${interval} ${i18next.t(declensionByNum(interval, PERIOD_CASES[period]), { ns: userLanguage })}`
    : ''
}
